import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

export interface PendingSuperBidData {
  pendingType?: string;
  redirectUrl?: string;
}

@Component({
  selector: 'app-dialog-pending-superbid',
  templateUrl: './dialog-pending-superbid.component.html',
  styleUrls: ['./dialog-pending-superbid.component.scss']
})
export class DialogPendingSuperbidComponent implements OnInit {
  pendingTypeLabel: string;
  redirectUrl: string;
  returnUrl: string;

  constructor(
    public dialogRef: MatDialogRef<DialogPendingSuperbidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PendingSuperBidData
  ) { }

  ngOnInit(): void {
    const type = (this.data?.pendingType || '').toString();
    this.pendingTypeLabel = this.superBidPendingType(type);
    this.redirectUrl = this.data?.redirectUrl;
  }

  resolvePending(): void {
    let callbackUrl = `${window.location.protocol}//${window.location.host}`;
    let authUrl = `${callbackUrl}/authorization/`;
    let redirectUrl = `${this.returnUrl}`;

    window.open(`${environment.superBidUrl}/signin?response_type=token&client_id=${environment.superBidClientId}&redirect_uri=${redirectUrl}&authorization_uri=${authUrl}&language=pt-BR&portal_id=2`, '_blank');
  }

  close(): void {
    this.dialogRef.close();
  }

  private superBidPendingType(type: string): string {
    const map: { [k: string]: string } = {
      FACE_CHECK: 'Reconhecimento facial',
      DOCUMENT: 'Documentos',
      EMAIL: 'E-mail',
      ACCOUNT_STATUS: 'Status da conta'
    };
    const key = type?.toUpperCase()?.replace(/\s+/g, '_');
    return map[key] || type || 'Pendência';
  }
}